<div class="container-fluid">
   
    <div class="row">
        <div class="card-body">
            <div class="row flex-row-reverse">
                <div class="col-12">
                    <button class="btn btn-secondary" href="javascript:void(0);"   *ngIf="caseService.case && caseService.case.settings.allowEditInvestigation"
                        (click)="CreateViolation(AddViolation);">
                        <i class="fa fa-plus-circle"></i>
                        <span>{{'AddViolation' | translate}}</span>
                    </button>
                </div>
                <div class="card">
                    <table class="table table-striped mt-3">
                        <thead class="thead-dark">
                            <tr>
                                <th>{{ "mainViolationTypeName" | translate }}</th>
                                <th>{{ "Description" | translate }}</th>
                                <!-- <th scope="col"> {{"Show" | translate }}</th> -->
                                <th scope="col"  *ngIf="caseService.case && caseService.case.settings.allowEditInvestigation">{{"Edit" | translate}}</th>
                                <th scope="col"  *ngIf="caseService.case && caseService.case.settings.allowEditInvestigation">{{"Delete" | translate}}</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let violation of ViolationsArr">
                                <td>{{ violation.mainViolationTypeName }}</td>
                                <td>{{ violation.material ? violation.material : "-"}}</td>
                              
                                <!-- <td>
                                    <a (click)="EditViolation(violation,ShowViolation)" href="javascript:void(0);">
                                        <i class="fa fa-eye"></i>
                                    </a>
                                </td> -->
                                <td  *ngIf="caseService.case && caseService.case.settings.allowEditInvestigation">
                                    <a (click)="EditViolation(violation,AddViolation)" href="javascript:void(0);">
                                        <i class="fa fa-edit"></i>
                                    </a>
                                </td>
                                <td  *ngIf="caseService.case && caseService.case.settings.allowEditInvestigation">
                                    <a (click)="DeleteViolation(violation.violationId, mymodal)"
                                        href="javascript:void(0);">
                                        <i class="fa fa-trash"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>



<!-- اضافة وتعديل  مخالفة -->

<ng-template #AddViolation let-modal>
    <div class="modal-header">
        <h4 *ngIf="isInsert==true" class="modal-title">
            {{ 'AddViolation' | translate }}
        </h4>
        <h4 *ngIf="isInsert==false" class="modal-title">
            {{ 'EditViolation' | translate }}
        </h4>
        <i style="font-size: 20px;" class="fa fa-close" (click)="modal.dismiss('Cross click');"></i>
    </div>
    <form novalidate="">
        <div class="modal-body">
            <div class="form-group  row">
                <div class="col-12 offset-1">
                    <div class="card">
                        <div class="form-group">
                            <div class="col-lg-12">
                                <div class="divformlabel">
                                    <label for="mainViolationType">{{'mainViolationType'|translate}}</label>
                                    <span *ngIf="mainViolationType.invalid" class="alert" style="color: red;
                                    white-space: nowrap;
                                    line-height: 0;
                                    padding: 0;
                                    margin-top: 8px;">
                                        <span *ngIf="mainViolationType.errors?.required">*</span>
                                    </span>
                                </div>
                                <ng-select [readonly]="isAdd" #mainViolationType="ngModel"
                                   id="mainViolationType"
                                    class="form-control-select" [items]="MainViolationsArr" bindLabel="violationName"
                                    bindValue="violationTypeId" [(ngModel)]="mainViolationTypeId"
                                    [ngModelOptions]="{ standalone: true }"
                                    placeholder="{{'mainViolationType' | translate}}" required>
                                </ng-select>
                            </div>
                         
                        </div>
                         
                        <div class="form-group col-lg-12 mt-1">
                            <div class="divformlabel">
                                <label>{{ "violationDescription" | translate }}</label>
                            </div>
                            <textarea  #violationDescription="ngModel"
                                name="violationDescription" id="violationDescription"
                                [(ngModel)]="ViolationDescription" type="text" class="form-control"
                                placeholder="{{ 'violationDescription' | translate }}"></textarea>

                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="modal-footer row" style="justify-content: space-between;padding: 1rem 2rem;">
            <button  *ngIf="isInsert==true" style="color: black;font-weight: bold;" type="button" class="btn btn-primary col-lg-3"
                data-bs-dismiss="modal"
                [disabled]="mainViolationType.invalid "
                (click)="onCreateViolation(modal);">
                {{"Add" | translate}}
            </button>
            <button  *ngIf="isInsert==false" style="color: black;font-weight: bold;" type="button" class="btn btn-primary col-lg-3"
            data-bs-dismiss="modal"
            [disabled]="mainViolationType.invalid"
            (click)="onEditViolation(modal);">
            {{"Edit" | translate}}
        </button>
            <button type="button" class="btn btn-dark col-lg-3" (click)="modal.dismiss('Cross click');">
                {{ "Close" | translate }}
            </button>
        </div>
    </form>

</ng-template>
<ng-template #mymodal let-modal>
    <div class="modal-header" style="justify-content: center">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "ConfirmDeleteOperation" | translate }}
        </h4>
    </div>
    <div class="modal-body text-center">
        <p>{{ "SelectedRecordwillbeDeleted" | translate }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDeleteViolation(modal)">
            {{ "YES" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "NO" | translate }}
        </button>
    </div>
</ng-template>